import script from "./PastDocumentations.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastDocumentations.vue?vue&type=script&setup=true&lang=ts"

import "./PastDocumentations.vue?vue&type=style&index=0&id=63f6df20&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f6df20"]])

export default __exports__